import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';

const useIsMultipleTemplate = () => {
  const { cnDisplaySettings } = useClinicalNoteContext();

  const isMultiTemplate = cnDisplaySettings?.templateView?.type === 'multiple';

  return !!isMultiTemplate;
};

export default useIsMultipleTemplate;
